export type LayoutType = 'mobile' | 'tablet' | 'laptop' | 'desktop';

export function WidthToLayoutType(width: number): LayoutType {
  if (width > 1440) {
    return 'desktop';
  }

  if (width > 768) {
    return 'laptop';
  }

  return 'tablet';
}
